(module =>{
    module.component('modalError', {
        template: require('./modalError.html'),
        bindings:{
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: [function(this: $TSFixMe) {
            var $ctrl = this;

            $ctrl.$onInit = () => {
                $ctrl.title = $ctrl.resolve.title;
                $ctrl.text = $ctrl.resolve.text;
                $ctrl.okText = $ctrl.resolve.okText;
                $ctrl.mode = $ctrl.resolve.mode;
                $ctrl.btnMode = 'primary';
            };

            $ctrl.ok = function () {
                $ctrl.close({});
            };
        }]
    });



})(angular.module('topline.modules'));